import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Block extends Modifier {
  static readonly baseTitle = 'Block';
  static readonly baseText =
    'Reduce stacks by the damage value, then reduce damage value by the same amount. Temporary.';
  static readonly baseIcon = 'shield';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.First;

  // Instance properties that can change
  title = Block.baseTitle;
  text = Block.baseText;
  icon = Block.baseIcon;
  tags: Array<ModifierTags> = [...Block.baseTags];
  priority = Block.basePriority;

  damageIn(damage: Damage) {
    let difference = this.stacks - damage.value;
    this.removeStacks(Math.min(this.stacks, damage.value));

    if (difference >= 0) {
      damage.value = 0;
    } else {
      damage.value = Math.abs(difference);
    }
  }

  startTurn() {
    this.removeStacks(this.stacks);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Block, Block);
